"use strict";

import Vue from 'vue';
import axios from "axios";
// import { Dialog } from 'vant'
// Vue.use(Dialog)
import reutrer from "../router/index";
import qs from 'qs' //格式化字符串工具
import Cookie from 'js-cookie'

// 自动判断当前环境
var thisUrl = window.location.origin

let config = {
    // 正式服
    baseURL: "https://apinew.5kjs.com/activity.teaching_textpaper/"
};

if (thisUrl.search(/test2.5kjs/g) != -1) {
    config.baseURL = "http://apinew2.5kjs.com/activity.teaching_textpaper/"
} else if (thisUrl.search(/test.5kjs/g) != -1) {
    config.baseURL = "http://apinew2.5kjs.com/activity.teaching_textpaper/"
} else if (thisUrl.search(/xueba.com/g) != -1) {
    config.baseURL = "http://apinew.xueba.com/activity.teaching_textpaper/"
} else if (thisUrl.search(/xueba.hk/g) != -1) {
    config.baseURL = "http://apinew.xueba.com/activity.teaching_textpaper/"
} else if (thisUrl.search(/localhost:/g) != -1) {
    config.baseURL = "http://apinew.xueba.com/activity.teaching_textpaper/"
} else {
    config.baseURL = "https://apinew.5kjs.com/activity.teaching_textpaper/"
}
// config.baseURL = "https://apinew.5kjs.com/activity.teaching_textpaper/"
const _axios = axios.create(config);

// 请求拦截器
_axios.interceptors.request.use(
    function(config) {
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

// 响应拦截器
// Add a response interceptor
_axios.interceptors.response.use(
    function(response) {
        if (response.data.code == 200) {
            if (response.data.data == null) {
                response.data.data = {
                    code: 200
                }
                return response.data
            }
            response.data.data.code = 200
            return response.data
        }
        if (response.data.code == 202) {
            // localStorage.removeItem('api_token')
            // Cookie.remove('api_token')
            // $.get(window.location.host == 'localhost:8080' ? 'http://hnjszp.xueba.com' + '/m/linklogout' : window.location.origin + '/m/linklogout', { token: localStorage.getItem('api_token'), link: window.location.host, url: window.location.href },
            //     function(res) {
            //         if (res.code == 1) {
            //             var localhost = window.location.href;
            //             window.location.href = localhost;
            //         }
            //     }
            // );
            return response.data
        }

        if (response.data.code == 404) {}
        return response.data
    },
    function(error) {
        // Do something with response error
        return Promise.reject(error);
    }
);

Plugin.install = function(Vue) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;